export enum StorageDatabasesPlatformAccessOperation {
    create = "4008f7a0-366b-4a24-9e09-8d4a91202c9e",
    read = "d10a08d3-0e24-4223-bcd1-9b27e2b3505b",
    update = "2fa9486b-b455-4274-90bf-bba85345670d",
    delete = "a05364fa-c83b-42be-ae70-0f8ce63124ba",
}
